module.exports = __webpack_public_path__ + "img/8.b062757b.svg";